/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { DOCUMENT } from '@angular/common';
import { Directive, ElementRef, effect, inject, input } from '@angular/core';

const ID = 'icon-dot-styles';

@Directive({
  selector: 'mat-icon[dot]',
  standalone: true,
})
export class IconDotDirective {
  private elementRef = inject(ElementRef);
  private document = inject(DOCUMENT);
  private addStyles() {
    if (this.document.querySelector(`[data-ref=${ID}]`)) return;
    const styles = `
      mat-icon.dot {
        overflow: visible;
      }
      mat-icon.dot:after {
        content: ' ';
        width: 8px;
        height: 8px;
        top: -7px;
        right: -7px;
        position: absolute;
        border-radius: 50%;
        background: var(--md-sys-color-tertiary);
      }
    `;

    const style = this.document.createElement('style');
    style.dataset.ref = ID;
    style.textContent = styles;

    this.document.head.appendChild(style);
  }

  public dot = input.required<boolean | null | undefined>();

  constructor() {
    this.addStyles();

    effect(() => {
      this.elementRef.nativeElement.classList.toggle('dot', this.dot());
    });
  }
}
